module.exports = __webpack_public_path__ + "assets/img/shop_btn_get.3965964f.png";